<script setup lang="ts">
import { computed } from 'vue';
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    color?: HTMLAttributes['color'];
}>();

const defaultColor = '#0073bd'; // Default value for the color attribute

const svgColor = computed(() => props.color || defaultColor);
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" :class="props.class">
        <g clip-path="url(#clip0_2106_27466)">
            <path
                d="M22 13.3545C21.9123 13.355 21.8253 13.3382 21.744 13.3051C21.6628 13.2719 21.5889 13.223 21.5267 13.1612L12 3.62787L2.47332 13.1612C2.34579 13.2704 2.18174 13.3275 2.01395 13.321C1.84617 13.3145 1.68701 13.245 1.56828 13.1262C1.44955 13.0075 1.37999 12.8484 1.37351 12.6806C1.36703 12.5128 1.4241 12.3487 1.53332 12.2212L11.5333 2.22121C11.6582 2.09704 11.8272 2.02734 12.0033 2.02734C12.1794 2.02734 12.3484 2.09704 12.4733 2.22121L22.4733 12.2212C22.5651 12.3148 22.6272 12.4333 22.6519 12.562C22.6767 12.6907 22.6629 12.8239 22.6124 12.9448C22.5619 13.0657 22.4769 13.1691 22.3679 13.242C22.259 13.3148 22.131 13.354 22 13.3545Z"
                :fill="svgColor" />
            <path
                d="M12 5.87891L4 13.9056V22.0189C4 22.3725 4.14048 22.7117 4.39052 22.9617C4.64057 23.2118 4.97971 23.3522 5.33333 23.3522H10V16.6856H14V23.3522H18.6667C19.0203 23.3522 19.3594 23.2118 19.6095 22.9617C19.8595 22.7117 20 22.3725 20 22.0189V13.8589L12 5.87891Z"
                :fill="svgColor" />
        </g>
        <defs>
            <clipPath id="clip0_2106_27466">
                <rect width="24" height="24" fill="white" transform="translate(0 0.6875)" />
            </clipPath>
        </defs>
    </svg>
</template>
